export const OWNER_TIER_LABELS: Record<string, string> = {
  BRONZE: 'Đồng',
  SILVER: 'Bạc',
  GOLD: 'Vàng',
  PLATINUM: 'Bạch kim',
  DIAMOND: 'Kim cương',
  LEGEND: 'Huyền thoại',
};

export const REVIEWER_TIER_LABELS: Record<string, string> = {
  NEW: 'Mới',
  APPRENTICE: 'Tập sự',
  EXPERIENCED: 'Có kinh nghiệm',
  TRUSTED: 'Uy tín',
  PROFESSIONAL: 'Chuyên nghiệp',
  ELITE: 'Tinh anh',
};

export const DISPUTE_STATUS_LABELS: Record<string, string> = {
  OPEN: 'Đang chờ xử lý',
  RESOLVED_REVIEWER: 'Đã xử lý — thắng cho người nhận việc',
  RESOLVED_OWNER: 'Đã xử lý — giữ nguyên quyết định chủ shop',
};
